<template>
    <body class="ovrflow">
        <div class="schedulechk_mainview_div">
            <header class="mob-display common--header">
                <b-row class="marginTopAlignment">
                    <b-col cols="2" v-on:click="backAction()"><img src="images/Back_white.svg" alt="" /></b-col>
                    <b-col cols="8" class="header-title text-center">SCHEDULE TEST</b-col>
                </b-row>
            </header>
            <header class="desk_display">
                <div id="header_content" class="common--header">
                    <p class="alignleft"></p>
                    <p class="aligncenter header-title">SCHEDULE TEST</p>
                    <p class="alignright" v-on:click="gomenu()">
                        <img src="images/Home@2x.png" alt v-b-toggle.sidebar-backdrop />
                    </p>
                </div>
                <div style="clearaligncenter: both"></div>
            </header>
            <b-container v-if="showSchedule" class="bv-example-row schedulechk_cont_height">
                <b-row align-h="center" class="row_height">
                    <b-col class="xs_col col-sm-10 col-md-7 col-lg-5">
                        <div class="checkerListDiv">
                            <b-row class="mob_lr_margin">
                                <label class="checkerHeading">{{ scheduleTestTitle }}</label>
                            </b-row>
                            <div>
                                <datepicker
                                    wrapper-class="calendarStyle"
                                    :format="customFormatter"
                                    v-model="form.date"
                                    input-class="checkerInputStyle zeroBottomMargin"
                                    placeholder="Date"
                                    :disabled-dates="form.state.disabledDates"
                                >
                                </datepicker>
                            </div>
                            <div class="">
                                <select
                                    name="Location"
                                    class="dropdownStyle"
                                    :disabled="disableFields"
                                    @change="onSelectLocation($event)"
                                    v-model="form.loctionValue"
                                >
                                    <option value="" hidden>Test Location</option>
                                    <option v-for="loctionValue in form.location" v-bind:key="loctionValue.name" :value="loctionValue.name">
                                        {{ loctionValue.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="">
                                <input
                                    class="checker_inputstyle"
                                    id="input-3"
                                    placeholder=""
                                    type="text"
                                    v-model="form.address"
                                    autocomplete="off"
                                    readonly
                                    required
                                />
                            </div>
                            <div class="" v-on:click="showTimeSlot">
                                <input
                                    class="checkerInputStyle_disabled"
                                    id="input-4"
                                    placeholder="Time"
                                    type="text"
                                    v-model="form.timeSlot12hrsFormat"
                                    autocomplete="off"
                                    readonly
                                    required
                                />
                                <span style="margin-left: -20px">
                                    <img src="images/time_Icon.svg" alt="" />
                                </span>
                            </div>
                        </div>

                        <div class="desk_display alignButtonToBottom" v-if="showSchedule">
                            <label v-if="errorStatus" class="register_errorMessageLabel" id="errorLabel"> {{ errorMessage }} </label>
                            <b-row align-h="center">
                                <b-col class="xs_col col-sm-12 col-md-12 col-lg-12 col_padding">
                                    <div class="btn-container_SpaceAdjusted text-center">
                                        <a href="javascript:void(0);" @click="fixSchedule" class="app--btn">CONFIRM</a>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row align-h="center">
                                <b-col class="xs_col col-sm-12 col-md-12 col-lg-12 col_padding">
                                    <div class="btn-container_SpaceAdjusted text-center">
                                        <a href="javascript:void(0);" @click="clear" class="app--btn">CLEAR</a>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <b-container class="noApptScheduleMsg desk_noApptScheduleMsg">
                <div v-if="!showSchedule" class="successMsgdiv">
                    <label class="thankyouText">{{ scheduleMsg }}</label>
                </div>
            </b-container>
            <div class="mob-display alignButtonToBottom" v-if="showSchedule">
                <label v-if="errorStatus" class="register_errorMessageLabel" id="errorLabel"> {{ errorMessage }} </label>
                <b-row align-h="center">
                    <b-col class="xs_col col-sm-8 col-md-7 col-lg-5">
                        <div class="btn-container_SpaceAdjusted text-center">
                            <a href="javascript:void(0);" @click="fixSchedule" class="app--btn">CONFIRM</a>
                        </div>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col class="xs_col col-sm-8 col-md-7 col-lg-5">
                        <div class="btn-container_SpaceAdjusted text-center">
                            <a href="javascript:void(0);" @click="clear" class="app--btn">CLEAR</a>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <!-- <b-container class="noApptScheduleMsg">
      <div v-if="!showSchedule" class="successMsgdiv">
        <label class="thankyouText">{{ scheduleMsg }}</label>
      </div>
    </b-container> -->

            <!-- Modal popover to pick the hours -->
            <b-modal
                ref="hour-modal"
                class="verticalCenterAlign"
                header-class="modal-header"
                :title="form.selectedHour"
                centered
                hide-footer
            >
                <div :style="hourgridStyle" class="card-list">
                    <button
                        v-for="item in slts"
                        v-on:click="buttonSelect(item)"
                        :id="item.slot"
                        :key="item.slot"
                        :disabled="isHrDisable(item)"
                        class="card-item"
                    >
                        {{ formatedHour(item.slot) }}
                    </button>
                </div>
                <div class="rightAlign">
                    <b-button class="modalButtonStyle" v-on:click="exitModal">{{ this.cancel }}</b-button>
                    <b-button class="modalButtonStyle" v-on:click="hourOkAction" :disabled="!modalHourButtonEnable">{{ this.ok }}</b-button>
                </div>
            </b-modal>

            <!-- Modal popover to pick the minutes -->
            <b-modal ref="minute-modal" class="verticalCenterAlign" :title="selectedMinutes" centered hide-footer>
                <div :style="minutegridStyle" class="card-list">
                    <button
                        v-for="min in form.minutes"
                        :key="min.s_time"
                        class="card-item"
                        :id="min.s_time"
                        :disabled="min.s_avl <= 0"
                        v-on:click="minutesButtonSelect(min.s_time)"
                    >
                        {{ formatedMinutes(min.s_time.split("-").join(":")) }}
                        <!-- {{ min.s_time.split("-").join(":") }} -->
                    </button>
                </div>

                <div class="rightAlign">
                    <b-button class="modalButtonStyle" v-on:click="exitModal">{{ this.cancel }}</b-button>
                    <b-button class="modalButtonStyle" v-on:click="minutesOkAction" :disabled="!modalMinutesButtonEnable">{{
                        this.ok
                    }}</b-button>
                </div>
            </b-modal>
        </div>
        <Footer></Footer>
    </body>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";
import Vue from "vue";
import moment from "moment";
import Footer from "@/components/footer";

export default {
    name: "",
    components: { Datepicker, Footer },
    data() {
        return {
            form: {
                date: "",
                location: [],
                loctionValue: "",
                address: "",
                timeSlot: "",
                timeSlot12hrsFormat: "",
                state: "",
                value: "",
                minutes: [],
                selectedHour: "",
            },
            numberOfColumns: 3,
            minutesNumberOfColumns: 2,
            selectedMinutes: "",
            selectedTimeSlot: "",
            store: store,
            enabledDatesFrom: "",
            enabledDatesTo: "",
            selectDate: {
                date: "",
            },
            slts: {},
            responseData: [],
            disableDateList: [],
            minuteAvailable: [],
            params: {
                iid: store.registration.iid,
                gid: store.groupDetail.gid,
                apton: "",
                fcid: "",
                s_id: "",
                s_time: "",
            },
            showSchedule: false,
            scheduleMsg: "",
            errorStatus: false,
            errorMessage: "",
            disableFields: true,
            modalHourButtonEnable: false,
            modalMinutesButtonEnable: false,
            showTestFacility: true,
        };
    },
    computed: {
        hourgridStyle() {
            return {
                gridTemplateColumns: `repeat(${this.numberOfColumns}, minmax(10px, 1fr))`,
            };
        },
        minutegridStyle() {
            return {
                gridTemplateColumns: `repeat(${this.minutesNumberOfColumns}, minmax(10px, 1fr))`,
            };
        },
    },
    methods: {
        formatedHour(item) {
            //Converting the time stamp from 24hours format to 12hours format
            var hours = parseInt(item);
            var min = ":00";
            var suffix = hours >= 12 ? " PM" : " AM";
            var hourValue = ((hours + 11) % 12) + 1 + min + suffix;

            return hourValue;
        },
        formatedMinutes(item) {
            //Converting the time stamp from 24hours format to 12hours format
            var hours = parseInt(item.substring(0, 2));
            var min = String(item.substring(2, 5));
            var suffix = hours >= 12 ? " PM" : " AM";
            var minValue = ((hours + 11) % 12) + 1 + min + suffix;

            return minValue;
        },
        isHrDisable(item) {
            for (var slot of item.solts) {
                if (slot.s_avl > 0) {
                    return false;
                }
            }
            return true;
        },
        backAction() {
            this.$router.push({ path: "/app-home" });
        },
        gomenu() {
            this.$router.push({ path: "/app-home" });
        },
        customFormatter(date) {
            this.selectDate.date = moment(date).startOf("day").format("M-D-YYYY");
            this.responseData = [];
            this.form.location = [];
            this.form.loctionValue = "";
            this.form.address = "";
            this.form.timeSlot = "";
            this.form.timeSlot12hrsFormat = "";
            this.disableFields = true;

            var header = {};
            //     headers: [
            //       {
            //         key: "Content-Type",
            //         value: "application/json",
            //         type: "text",
            //       },
            //     ],
            //   };

            apiCall
                .apiServiceCall("Post", "", "/schedule/slots/", this.selectDate, header)
                .then((response) => {
                    if (response.data.status == 1) {
                        var facility = [];
                        for (let i = 0; i < response.data.data.length; i++) {
                            var todayDate = moment(new Date()).startOf("day").format("M-D-YYYY");

                            if (todayDate == this.selectDate.date) {
                                var facilityData = response.data.data[i].slts;
                                // facility.push(response.data.data[i].fc);

                                var slotsRes = [];
                                var res = [];

                                for (let ij = 0; ij < facilityData.length; ij++) {
                                    var facilityHour = parseInt(facilityData[ij].slot);
                                    var currentHour = parseInt(moment(new Date()).format("HH")); //parseInt("11");
                                    // TODO
                                    var currentTime = moment(new Date());
                                    // var currentTime = moment(new Date("9-30-2020 11:29"));
                                    if (currentHour < facilityHour || currentHour == facilityHour) {
                                        // TODO
                                        if (currentHour == facilityHour) {
                                            var minArray = [];
                                            var slotsArray = [];
                                            for (let time = 0; time < facilityData[ij].solts.length; time++) {
                                                minArray.push(facilityData[ij].solts[time].s_time.split("-").join(":"));
                                            }
                                            for (let j = 0; j < minArray.length; j++) {
                                                var s = todayDate + " " + minArray[j];
                                                var d = new Date(s);
                                                var toTime = moment(d).add(response.data.data[i].fc.sdur, "m").toDate();

                                                if (currentTime > d && currentTime < toTime) {
                                                    slotsArray.push(facilityData[ij].solts[j]);
                                                } else if (currentTime <= toTime && currentTime <= d) {
                                                    slotsArray.push(facilityData[ij].solts[j]);
                                                } else if (currentTime > toTime && currentTime > d) {
                                                    console.log("Passed Time");
                                                } else {
                                                    console.log("else");
                                                }
                                            }
                                            slotsRes.push({
                                                slot: facilityData[ij].slot,
                                                solts: slotsArray,
                                            });
                                        } else {
                                            slotsRes.push({
                                                slot: facilityData[ij].slot,
                                                solts: facilityData[ij].solts,
                                            });
                                        }
                                    }
                                }
                                if (slotsRes.length > 0) {
                                    res.push({
                                        slts: slotsRes,
                                        fcid: response.data.data[i].fcid,
                                        s_id: response.data.data[i]._id,
                                    });
                                    Vue.set(this.responseData, response.data.data[i].fc.name, res);

                                    this.removeUnAvailableFacility(res);
                                    if (this.showTestFacility) {
                                        facility.push(response.data.data[i].fc);
                                    }
                                }
                            } else {
                                var res1 = [];
                                res1.push({
                                    slts: response.data.data[i].slts,
                                    fcid: response.data.data[i].fcid,
                                    s_id: response.data.data[i]._id,
                                });
                                Vue.set(this.responseData, response.data.data[i].fc.name, res1);

                                this.removeUnAvailableFacility(res1);

                                if (this.showTestFacility) {
                                    facility.push(response.data.data[i].fc);
                                }
                            }
                        }
                        if (Object.keys(this.responseData).length <= 0 || facility.length <= 0) {
                            this.disableFields = true;
                            this.errorStatus = true;
                            this.errorMessage = this.noTestFacilityAvailable;
                        } else {
                            this.disableFields = false;
                            this.errorStatus = false;
                        }

                        this.form.location = facility;
                    } else {
                        this.errorStatus = true;
                        this.errorMessage = response.data.message;
                    }
                })
                .catch((error) => {
                    if (error.response.status == 500) {
                        this.errorStatus = true;
                        this.errorMessage = this.serverProblem;
                    } else if (error.response.status == 401) {
                        setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                    } else if (error.response.status == 504) {
                        this.signout();
                    } else {
                        this.errorStatus = true;
                        this.errorMessage = error.response.data.message;
                    }
                });
            return moment(date).format("M/D/YYYY");
        },
        removeUnAvailableFacility(res1) {
            for (var capacity = 0; capacity < res1[0].slts.length; capacity++) {
                var soltsCapacity = res1[0].slts[capacity].solts;
                this.showTestFacility = false;
                for (var slot of soltsCapacity) {
                    if (slot.s_avl > 0) {
                        this.showTestFacility = true;
                        return;
                    }
                }
            }
        },
        onSelectLocation(event) {
            document.getElementById("input-4").className = "checkerInputStyle_disabled";
            for (let i = 0; i < this.form.location.length; i++) {
                if (this.form.location[i].name == event.target.value) {
                    this.form.address = this.form.location[i].adrs.str.concat(
                        ", ",
                        this.form.location[i].adrs.cty,
                        ", ",
                        this.form.location[i].adrs.st
                    );
                    document.getElementById("input-4").className = "checkerInputStyle";
                }
            }
            var selectedKey = event.target.value;
            var selectedFacility = this.responseData[selectedKey];
            this.params.fcid = selectedFacility[0].fcid;
            this.params.s_id = selectedFacility[0].s_id;
            this.slts = selectedFacility[0].slts;
        },
        buttonSelect(selectedID) {
            // this.form.selectedHour = selectedID.slot.concat(" : 00");
            this.form.selectedHour = this.formatedHour(selectedID.slot);

            for (let i = 0; i < this.slts.length; i++) {
                if (this.slts[i].slot == selectedID.slot) {
                    document.getElementById(selectedID.slot).className = "card-item-with_background";
                } else {
                    document.getElementById(this.slts[i].slot).className = "card-item";
                }
            }

            this.form.minutes = selectedID.solts;
            this.modalHourButtonEnable = true;
        },
        minutesButtonSelect(selectedID) {
            this.modalMinutesButtonEnable = true;
            for (let i = 0; i < this.form.minutes.length; i++) {
                if (this.form.minutes[i].s_time == selectedID) {
                    document.getElementById(this.form.minutes[i].s_time).className = "card-item-with_background";
                } else {
                    document.getElementById(this.form.minutes[i].s_time).className = "card-item";
                }
            }
            // this.selectedMinutes = selectedID.split("-").join(":");
            this.selectedTimeSlot = selectedID.split("-").join(":");
            this.selectedMinutes = this.formatedMinutes(selectedID.split("-").join(":"));
        },
        showTimeSlot() {
            this.modalHourButtonEnable = false;
            this.modalMinutesButtonEnable = false;
            this.form.selectedHour = "";
            this.selectedMinutes = "";
            this.selectedTimeSlot = "";
            if (this.form.address.length > 0) {
                this.$refs["hour-modal"].show();
            }
        },
        hideModal() {
            this.$refs["hour-modal"].hide();
        },
        exitModal() {
            this.$refs["hour-modal"].hide();
            this.$refs["minute-modal"].hide();
            this.modalHourButtonEnable = false;
            this.modalMinutesButtonEnable = false;
        },
        fixSchedule() {
            if (this.form.date.length == 0 || this.form.loctionValue.length == 0 || this.form.timeSlot.length == 0) {
                this.errorStatus = true;
                this.errorMessage = this.selectAllFields;
            } else {
                //Replace - from time slot with :
                var correctedTime = this.form.timeSlot.split("-").join(":");
                var newDateString = moment(this.form.date).startOf("day").format("M-D-YYYY");
                newDateString = newDateString.concat(" ", correctedTime);

                this.params.apton = newDateString;
                this.params.s_time = this.form.timeSlot.split(":").join("-");

                if (navigator.onLine) {
                    var header = {};
                    //     headers: [
                    //       {
                    //         key: "Content-Type",
                    //         value: "application/json",
                    //         type: "text",
                    //       },
                    //     ],
                    //   };

                    apiCall
                        .apiServiceCall("Update", "", "/appt/", this.params, header)
                        .then((response) => {
                            if (response.data.status == 1) {
                                store.isAppointment = true;
                                this.$router.push({ path: "/app-home" });
                            } else {
                                this.errorStatus = true;
                                this.errorMessage = response.data.message;
                            }
                        })
                        .catch((error) => {
                            if (error.response.status == 500) {
                                this.errorStatus = true;
                                this.errorMessage = this.serverProblem;
                            } else if (error.response.status == 401) {
                                setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                            } else if (error.response.status == 504) {
                                this.signout();
                            } else {
                                this.errorStatus = true;
                                this.errorMessage = error.response.data.message;
                            }
                        });
                } else {
                    this.errorStatus = true;
                    this.errorMessage = this.checkInternetConnection;
                }
            }
        },
        clear() {
            this.form.date = "";
            this.form.loctionValue = "";
            this.form.address = "";
            this.form.timeSlot = "";
            (this.form.timeSlot12hrsFormat = ""), (this.slts = "");
            this.disableFields = true;
            document.getElementById("input-4").className = "checkerInputStyle_disabled";
        },
        hourOkAction() {
            this.$refs["hour-modal"].hide();
            this.$refs["minute-modal"].show();
            this.form.selectedHour = "";
        },
        minutesOkAction() {
            this.$refs["minute-modal"].hide();
            this.form.timeSlot = this.selectedTimeSlot.split("-").join(":");
            this.form.timeSlot12hrsFormat = this.selectedMinutes.split("-").join(":");
            this.selectedMinutes = "";
            this.selectedTimeSlot = "";
        },
        disableDatesInCalender() {
            //Disable all the dates in the calender expect the given date range
            this.form.state = {
                disabledDates: {
                    to: new Date(this.enabledDatesFrom), // Disable all dates up to specific date
                    from: new Date(moment(this.enabledDatesTo).add(1, "days")), // Disable all dates after specific date
                },
            };
        },
    },
    mounted() {
        if (navigator.onLine) {
            var urlString = "/schedule/asn-date";
            apiCall
                .apiServiceCall("GetOne", "", urlString, "", "")
                .then((response) => {
                    if (response.data.status == 1) {
                        if (response.data.data.gid != undefined) {
                            this.enabledDatesFrom = moment(response.data.data.fdt.split("T")[0]).utc().toISOString();
                            this.enabledDatesTo = moment(response.data.data.ldt.split("T")[0]).utc().toISOString();
                            this.showSchedule = true;
                            //Disable all the dates in the calender expect the given date range
                            this.disableDatesInCalender();
                        } else {
                            this.showSchedule = false;
                            this.scheduleMsg = "No Test Scheduled";
                        }
                    } else {
                        this.showSchedule = false;
                        this.scheduleMsg = "No Test Scheduled";
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status) {
                        switch (error.response.status) {
                            case 500: // internal server rror
                                this.errorStatus = true;
                                this.errorMessage = this.serverProblem;
                                break;
                            case 401: // unauthorized
                                setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                                break;
                            case 504: // gateway timeout
                                this.signout();
                                break;
                            default:
                                this.showSchedule = false;
                                this.scheduleMsg = error.response.data.message;
                                break;
                        }
                    } else {
                        console.log('Error: ' + error.message);
                    }
                });
        } else {
            this.errorStatus = true;
            this.errorMessage = this.checkInternetConnection;
        }
    },
};
</script>
